import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-stepped-reward-consequence',
  templateUrl: './stepped-reward-consequence.component.html',
  styleUrls: ['./stepped-reward-consequence.component.scss'],
})
export class SteppedRewardConsequenceComponent {
  @Input() steppedReward: any;
  @Input() rewardTypes: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  initConsequenceObject(): void {
    console.log(this.steppedReward);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$SteppedReward',
    };
    if (this.steppedReward) {
      this.steppedReward.push(tmpObj);
    } else {
      this.steppedReward = [];
      this.steppedReward.push(tmpObj);
    }
    console.log(this.steppedReward);
  }

  updateConsequences() {
    this.debouncer.next(this.steppedReward);
  }

  removeConsequence(consequence) {
    this.steppedReward.splice(this.steppedReward.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
